import Game from './Game';
import { Team } from './Team';
import { CounterNode } from './graph';
import NatsObject from './lib/NatsObject';

export type CounterData = {
	id: string;
	version: string;
	game_id: string;
	team_id: string;
	name: string;
	value: number;
	extra?: any;
};

export class Counter extends NatsObject<CounterData> {
	data: CounterNode;
	game: Game;
	team?: Team;

	constructor(data: CounterNode, game: Game, team?: Team) {
		super(game.client, `${game.data.id}.counter.${data.id}`);
		this.data = data;
		this.game = game;
		this.team = team;
	}

	updateFromEvent (data: CounterData) {
		this.data = data;
	}

	async add (value: number) {
		return await this.client.request<CounterData>('counter.add', {
			id: this.data.id,
			version: this.data.version,
			value,
		});
	}

	async set (value: number) {
		return await this.client.request<CounterData>('counter.set', {
			id: this.data.id,
			version: this.data.version,
			value,
		});
	}
}

export { Counter as default };
